// 10 industry-focused landing pages. Each becomes /sanaye/<slug>.
// Real, hand-written Persian content for each industry's food needs.
export const INDUSTRIES = [
    {
        slug: 'tech-startup',
        name: 'شرکت‌های فناوری و استارتاپی',
        intro: 'تیم‌های فناوری معمولاً جوان، پرکار و با ساعات کاری منعطف هستند. کارمندان به دنبال تنوع، انتخاب آزاد و گزینه‌های سالم در منوی روزانه‌اند.',
        challenges: [
            'تنوع ذائقه‌ی گسترده در تیم‌های جوان',
            'تقاضای زیاد برای گزینه‌های گیاهی و سالم',
            'برخی روزها تیم در دفتر، برخی روزها دورکار',
            'بودجه محدود استارتاپ‌ها',
        ],
        solutions: [
            'منوی روزانه با ۴ تا ۶ انتخاب آزاد برای هر کارمند',
            'حداقل یک گزینه گیاهی و یک گزینه سبک هر روز',
            'سفارش انعطاف‌پذیر — کارمند تا ۱۰ صبح می‌تواند تغییر دهد',
            'قیمت‌گذاری مقیاس‌پذیر برای تیم‌های ۱۵ تا ۲۰۰ نفر',
        ],
        menuFocus: 'ترکیبی از پاستا و فست‌فود سالم، غذای ایرانی، خوراک گریل و سالادهای بزرگ.',
        scale: 'تیم‌های ۱۵ تا ۲۰۰ نفر',
        related: ['fintech-banking', 'design-agency', 'large-corporation', 'manufacturing'],
    },
    {
        slug: 'fintech-banking',
        name: 'بانک‌ها، فین‌تک و خدمات مالی',
        intro: 'کارمندان بانکی و فین‌تک معمولاً در دفاتر بزرگ مرکزی شهر هستند و وعده ناهار آن‌ها در ساعت مشخصی است. کیفیت ثابت و فاکتور رسمی برای واحد حسابداری از مزایای ضروری است.',
        challenges: [
            'تعداد بالای پرسنل (۵۰ تا ۵۰۰ نفر)',
            'محدودیت زمان وعده ناهار (۴۵ دقیقه تا ۱ ساعت)',
            'سختی پارکینگ و ترافیک ساختمان‌های مرکزی',
            'الزام فاکتور و گزارش رسمی برای واحد مالی',
        ],
        solutions: [
            'توان تحویل سفارش ۵۰۰ نفر در یک نوبت',
            'تحویل قبل از ساعت ۱۲ تضمینی',
            'هماهنگی با مدیریت ساختمان برای دسترسی سریع',
            'فاکتور رسمی PDF و گزارش تفکیک‌شده ماهانه',
        ],
        menuFocus: 'منوی استاندارد ایرانی با کیفیت ثابت روزانه — کباب، خورشت‌ها، باقالی‌پلو و مرغ زعفرانی.',
        scale: 'دفاتر ۵۰ تا ۵۰۰ نفر',
        related: ['large-corporation', 'tech-startup', 'government-office', 'legal-firm'],
    },
    {
        slug: 'manufacturing',
        name: 'کارخانه‌ها و شرکت‌های تولیدی',
        intro: 'پرسنل تولیدی ساعات کاری شیفت‌بندی شده و نیاز به وعده‌های پرحجم و پرکالری دارند. کیفیت بسته‌بندی برای حفظ گرمای غذا تا زمان شیفت مهم است.',
        challenges: [
            'شیفت‌های مختلف کاری (صبح، عصر، شب)',
            'نیاز به وعده‌های پرحجم برای کار سخت',
            'فاصله بین تولید و آشپزخانه',
            'تنوع پرسنل تولیدی، اداری و مدیریتی',
        ],
        solutions: [
            'تحویل دو نوبت در روز (ناهار و شام)',
            'بسته‌بندی گرمانگه‌دار صنعتی',
            'منوی متنوع برای رده‌های مختلف پرسنل',
            'قیمت ویژه برای حجم بالا',
        ],
        menuFocus: 'غذاهای پرحجم ایرانی، کباب، خورشت، پلوهای سنتی، آبگوشت — وعده‌های سیرکننده.',
        scale: 'پرسنل ۱۰۰ تا ۱۰۰۰ نفر در شیفت',
        related: ['warehouse-logistics', 'construction', 'large-corporation', 'government-office'],
    },
    {
        slug: 'design-agency',
        name: 'آژانس‌های تبلیغاتی و طراحی',
        intro: 'تیم‌های خلاق و طراحی به‌دنبال غذای متفاوت، تجربه‌ی متمایز و گزینه‌های زیبا هستند. ارائه و کیفیت ظاهری غذا برای این مخاطبان مهم است.',
        challenges: [
            'انتظار بالا از کیفیت ارائه',
            'ذائقه‌ی متفاوت تیم خلاق',
            'دفاتر کوچک ۱۰ تا ۴۰ نفر',
            'برنامه‌های نامنظم — جلسات تا دیروقت',
        ],
        solutions: [
            'منوی متمایز با ارائه شیک و عکس‌محور',
            'گزینه‌های فرنگی و فیوژن متنوع',
            'حداقل سفارش پایین (۱۰ نفر)',
            'پذیرایی جلسات تا ساعت ۹ شب',
        ],
        menuFocus: 'گزینه‌های فرنگی (پاستا، پیتزا، سالادهای ویژه)، فیوژن، غذاهای مدرن.',
        scale: 'تیم‌های ۱۰ تا ۴۰ نفر',
        related: ['tech-startup', 'media-publishing', 'education-private', 'legal-firm'],
    },
    {
        slug: 'media-publishing',
        name: 'رسانه‌ها، انتشارات و فرهنگی',
        intro: 'دفاتر مجلات، انتشارات و رسانه‌های آنلاین، تیم‌های متنوعی با ساعات کاری منعطف دارند. غذای ایرانی کلاسیک و گزینه‌های گیاهی، انتخاب محبوب این مخاطبان است.',
        challenges: [
            'ساعت‌های کاری غیرمنظم',
            'برنامه‌های رویدادی و کارگاهی',
            'تیم‌های ترکیبی (نویسنده، طراح، تصویرگر)',
            'بودجه متعادل',
        ],
        solutions: [
            'منوی روزانه با گزینه‌های متعادل قیمتی',
            'پذیرایی رویدادها و کارگاه‌ها',
            'گزینه‌های گیاهی و رژیمی',
            'فاکتور ماهانه و گزارش‌گیری',
        ],
        menuFocus: 'غذای ایرانی کلاسیک، گزینه‌های گیاهی، منوی متعادل قیمتی.',
        scale: 'دفاتر ۱۰ تا ۸۰ نفر',
        related: ['design-agency', 'education-private', 'tech-startup', 'legal-firm'],
    },
    {
        slug: 'government-office',
        name: 'ادارات دولتی و نیمه‌دولتی',
        intro: 'ادارات دولتی نیازمند فاکتور رسمی با مدارک کامل، قیمت متعادل و کیفیت ثابت هستند. تجربه با سیستم‌های حسابداری دولتی برای کارفرما اهمیت دارد.',
        challenges: [
            'فرآیند رسمی پرداخت و فاکتور',
            'تعداد بالای پرسنل دولتی',
            'محدودیت بودجه دولتی',
            'الزام به مدارک رسمی برای ممیزی',
        ],
        solutions: [
            'فاکتور رسمی PDF با همه مدارک ضروری',
            'گزارش تفکیک‌شده برای ممیزی',
            'قیمت متعادل برای بودجه دولتی',
            'تجربه قرارداد با ادارات قبلی',
        ],
        menuFocus: 'منوی استاندارد ایرانی، کباب، خورشت‌ها، پلوهای سنتی.',
        scale: 'ادارات ۵۰ تا ۳۰۰ نفر',
        related: ['fintech-banking', 'manufacturing', 'large-corporation', 'education-private'],
    },
    {
        slug: 'legal-firm',
        name: 'دفاتر حقوقی و حسابرسی',
        intro: 'دفاتر حقوقی و حسابرسی، مشتری کلاسیک و سنتی برای خدمات غذای کارمندی هستند. کیفیت ثابت، حضور به‌موقع و فاکتور رسمی از الزامات اولیه است.',
        challenges: [
            'محیط رسمی — تمیزی و دقت در ارائه مهم',
            'دفاتر کوچک تا متوسط (۱۵ تا ۵۰ نفر)',
            'ذائقه کلاسیک و متعادل',
            'حساسیت به برند و کیفیت',
        ],
        solutions: [
            'بسته‌بندی متمایز و تمیز',
            'تحویل به‌موقع تضمینی',
            'منوی کلاسیک ایرانی',
            'فاکتور رسمی منظم',
        ],
        menuFocus: 'غذای ایرانی کلاسیک، کباب، خورشت‌ها — متعادل و باکیفیت.',
        scale: 'دفاتر ۱۵ تا ۵۰ نفر',
        related: ['fintech-banking', 'design-agency', 'government-office', 'large-corporation'],
    },
    {
        slug: 'education-private',
        name: 'مدارس و مؤسسات آموزشی خصوصی',
        intro: 'مدارس خصوصی، مؤسسات کنکور و آموزشگاه‌های زبان نیازمند منوی متناسب با کودکان و نوجوانان، بهداشتی بالا و قیمت متعادل هستند.',
        challenges: [
            'منوی متناسب با کودکان و نوجوانان',
            'حساسیت بالا روی بهداشت',
            'تنوع سنی پرسنل و دانش‌آموزان',
            'بودجه آموزشی',
        ],
        solutions: [
            'منوی کودک‌پسند با گزینه‌های متعادل',
            'تأییدیه بهداشت کامل و کارت سلامت پرسنل',
            'منوی جداگانه برای پرسنل و دانش‌آموزان',
            'قیمت ویژه برای مدارس',
        ],
        menuFocus: 'غذاهای کودک‌پسند (پاستا، پیتزا، خوراک مرغ)، گزینه‌های متعادل ایرانی.',
        scale: 'مدارس ۱۰۰ تا ۶۰۰ دانش‌آموز',
        related: ['design-agency', 'media-publishing', 'tech-startup', 'government-office'],
    },
    {
        slug: 'large-corporation',
        name: 'شرکت‌های بزرگ و چندملیتی',
        intro: 'دفاتر منطقه‌ای شرکت‌های چندملیتی و هلدینگ‌های بزرگ ایرانی، نیازمند سرویس استاندارد بین‌المللی، گزارش‌گیری دقیق و امکان مقیاس‌پذیری هستند.',
        challenges: [
            'تعداد بالای پرسنل (۲۰۰ تا ۲۰۰۰+ نفر)',
            'استاندارد بین‌المللی برای ارائه',
            'گزارش‌گیری بسیار دقیق برای دفتر مرکزی',
            'هماهنگی با چند ساختمان همزمان',
        ],
        solutions: [
            'توان تحویل سفارش ۲۰۰۰+ نفر',
            'بسته‌بندی استاندارد بین‌المللی',
            'پنل مدیریت اختصاصی با گزارش‌های پیشرفته',
            'پشتیبانی ۲۴ ساعته اختصاصی',
        ],
        menuFocus: 'منوی متنوع — ایرانی، فرنگی، گیاهی — با کیفیت بین‌المللی.',
        scale: 'دفاتر ۲۰۰ تا ۲۰۰۰+ نفر',
        related: ['fintech-banking', 'manufacturing', 'tech-startup', 'government-office'],
    },
    {
        slug: 'warehouse-logistics',
        name: 'انبارها، لجستیک و توزیع',
        intro: 'پرسنل انبارها و شرکت‌های لجستیک کار سخت و ساعات طولانی دارند. وعده‌های پرحجم، پرکالری و آماده برای حمل از مزایای اصلی است.',
        challenges: [
            'کار فیزیکی سخت و نیاز به انرژی بالا',
            'ساعات کاری شیفت‌بندی',
            'مکان دور از آشپزخانه‌ها',
            'بودجه متعادل کسب‌وکار لجستیک',
        ],
        solutions: [
            'وعده‌های پرحجم و سیرکننده',
            'تحویل به‌موقع برای شیفت‌های مختلف',
            'بسته‌بندی مقاوم برای حمل و جابجایی',
            'قیمت ویژه برای پرسنل لجستیک',
        ],
        menuFocus: 'غذاهای پرحجم ایرانی — کباب، خورشت، پلوهای سیرکننده، آبگوشت.',
        scale: 'پرسنل ۳۰ تا ۳۰۰ نفر',
        related: ['manufacturing', 'construction', 'government-office', 'large-corporation'],
    },
    {
        slug: 'construction',
        name: 'پروژه‌های ساختمانی و عمرانی',
        intro: 'پروژه‌های ساختمانی و عمرانی به وعده‌های پرحجم برای کارگران و گزینه‌های ویژه برای مدیران پروژه نیاز دارند. تحویل به محل پروژه از چالش‌های اصلی است.',
        challenges: [
            'تحویل به محل پروژه (نه دفتر ثابت)',
            'تعداد متغیر پرسنل پروژه',
            'دو دسته پرسنل: کارگر و مدیریت',
            'شرایط محل پروژه (گرد و خاک، فضای محدود)',
        ],
        solutions: [
            'تحویل به سایت پروژه با هماهنگی روزانه',
            'بسته‌بندی صنعتی مقاوم',
            'منوی دو سطح: کارگری و مدیریتی',
            'انعطاف در تعداد سفارش روزانه',
        ],
        menuFocus: 'غذای ایرانی سنتی، کباب، خورشت — به‌علاوه‌ی گزینه‌های متمایز برای جلسات مدیریت.',
        scale: 'پروژه‌های ۲۰ تا ۲۰۰ نفر',
        related: ['manufacturing', 'warehouse-logistics', 'government-office', 'large-corporation'],
    },
];
export const INDUSTRY_SLUGS = INDUSTRIES.map((i) => i.slug);
